import { useEffect } from "react";
import axios from "axios";
import { message } from "antd";
import { v4 as uuidv4 } from "uuid";

export default function useStorySentences({
  storyId, selectedSentences, setSelectedSentences, deletedSentences, setDeletedSentences, selectedCharacters,
}) {
  //#region LOAD SENTENCES
  useEffect(() => {
    let isMounted = true;
    const fetchData = async () => {
      try {
        const res = await axios.get(`/api/sentences/?storyid=${storyId}`);
        if (isMounted) {
            console.log("[useStorySentences]res data sentences:: ", res.data);
          const loadedSentences = res.data.map((s) => ({
            ...s,
            localCharacterId: s.characterid, // store original for remapping
          }));

          setSelectedSentences(loadedSentences);

          if (loadedSentences.length > 0) {           
            console.log("[useStorySentences]res loaded sentences text:: ", res.data);
          } else {
            console.log("No sentences found.");
          }
        }
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
    return () => {
      isMounted = false;
    };
  }, [storyId]);
  //#endregion

  //#region ADD


  const handleAddSentence = () => {
    setSelectedSentences((prev) => {
      const newSentence = {
        localId: uuidv4(),
        text: "",
        characterid:
          selectedCharacters?.length > 0
            ? selectedCharacters[0].id || selectedCharacters[0].localId
            : null,
      };
  
      return [
        ...prev,
        {
          ...newSentence,
          ord: prev.length + 1, 
        },
      ];
    });
  };


  //#endregion

  //#region UPDATE
  const handleSentencesInputChange = (e, index) => {
    const { name, value } = e.target;
  
    setSelectedSentences((prev) => {
      const updated = [...prev];
  
      updated[index] = {
        ...updated[index],
        [name]: value,
      };
  
      return updated;
    });
  };
  //#endregion

  //#region DELETE
  const handleRemoveSentence = (index) => {

    console.log("sentence index", index);

    console.log("SelectedSentences before::",selectedSentences);

    console.log("deletedSentences before::",deletedSentences);

    const updatedSentences = [...selectedSentences];
    const removed = updatedSentences.splice(index, 1)[0];

    // If the sentence already exists in DB, track its ID for deletion
    if (removed.id) {
      setDeletedSentences((prev) => [...prev, removed.id]);
    }

    setSelectedSentences(updatedSentences);

    console.log("SelectedSentences after::",selectedSentences);

    console.log("deletedSentences after::",deletedSentences);
  };
  //#endregion

  //#region DELETE FROM DB
  const deleteSentencesFromDB = async () => {
    if (!deletedSentences?.length) return;

    try {
      for (const id of deletedSentences) {
        await axios.delete(`/api/sentences/${id}`);
      }

      setDeletedSentences([]);

      message.success("Sätze gelöscht.");
    } catch (err) {
      console.error(err);
      message.error("Fehler beim Löschen.");
    }
  };
  //#endregion

  //#region SAVE
  const saveSentences = async (
    sentences,
    storyId,
    characterIdMapping = {},
    mode
  ) => {
    try {
      if (!storyId) {
        message.error("Missing storyId");
        return false;
      }
      console.log("[useStorySentences] SENTENCES BEING SAVED:", sentences);
  
      for (let i = 0; i < sentences.length; i++) {
        const sentence = sentences[i];
  
        const ord = i + 1;
  
        // resolve character id safely
        let characterId = sentence.characterid;
  
        if (sentence.localCharacterId && characterIdMapping[sentence.localCharacterId]) {
          characterId = characterIdMapping[sentence.localCharacterId];
        }
  
        if (sentence.characterid && characterIdMapping[sentence.characterid]) {
          characterId = characterIdMapping[sentence.characterid];
        }
  
        const payload = {
          ord,
          storyid: storyId,
          text: sentence.text || "",
          characterid: characterId,
        };

        console.log("[useStorySentences] SENTENCES payload", payload);
  
        const isExisting = !!sentence.id; // DB sentence
        const isEditMode = mode === "edit";
  
        if (isEditMode) {
          // UPDATE existing sentence
          if (isExisting) {
            await axios.put(`/api/sentences/${sentence.id}`, payload);
          } else {
            // NEW sentence created during edit → INSERT
            const res = await axios.post("/api/sentences", payload);
            console.log("[useStorySentences] SENTENCES POST RESPONSE", res.data);
            setSelectedSentences(prev =>
                prev.map((s, idx) =>
                  idx === i ? { ...s, id: res.data.newID } : s
                )
              );
          }
        } else {
          // CREATE MODE → always insert
          const res = await axios.post("/api/sentences", payload);
          setSelectedSentences(prev =>
            prev.map((s, idx) =>
              idx === i ? { ...s, id: res.data.newID } : s
            )
          );
        }
      }
  
      // DELETE AFTER save (correct order)
      await deleteSentencesFromDB();
  
      return true;
    } catch (err) {
      console.error("Error saving sentences:", err);
      message.error("Failed saving sentences");
      return false;
    }
  };
  //#endregion

  //#region CHARACTER CLEANUP
  const removeCharacterReferences = (
    removedCharacterId
  ) => {
    setSelectedSentences((prev) =>
      prev.filter(
        (s) => s.characterid !== removedCharacterId
      )
    );
  };
  //#endregion




  const handleDrop = (fromIndex, toIndex) => {
    if (fromIndex == null || fromIndex === toIndex) return;
  
    setSelectedSentences((prev) => {
      const updated = [...prev];
  
      const [moved] = updated.splice(fromIndex, 1);
      updated.splice(toIndex, 0, moved);
  
      return updated.map((s, i) => ({
        ...s,
        ord: i + 1,
      }));
    });
  };





  //#region RESET
  const resetSentences = () => {
    setSelectedSentences([]);
    setDeletedSentences([]);
  };
  //#endregion

  return {
    selectedSentences, deletedSentences,
    handleAddSentence, handleRemoveSentence,

    saveSentences, deleteSentencesFromDB,
    removeCharacterReferences,
    resetSentences,

    handleSentencesInputChange,


    handleDrop,

  };
}